import {ProfileUserDetailsComponent} from './profile-user-details';
import {ProfileUserRoleDetailsComponent} from "./profile-user-role-details";
import {ProfileUserRoleAccountsDetailsComponent} from "./profile-user-role-accounts-details";

export const SHARED_PROFILE_USER_COMPONENTS = [
    ProfileUserDetailsComponent,
    ProfileUserRoleDetailsComponent,
    ProfileUserRoleAccountsDetailsComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/profile-user/index.ts